export default __webpack_public_path__ + "static/deepwatersLogoVatnForm-188c211f7e15dc1f10371d2d8a8754e3.svg";